import { get } from '@/api';

export async function getEmployments() {
  return (await get('api/widget/employments')).body.data;
}
